<template>
    <div class="cons">
        <div class="cns">
            <div class="pointro" style="margin-top: 0;">
                <div class="companyinfo flx alc jsb cursor">
                    <div class="cileft flx alc">
                        <img :src="$img(info.shop_avatar)" alt="" />
                        <div class="" flx>
                            <div class="comname" v-text="info.shop_name"></div>
                            <!-- <div class="conma" v-text="`${info.shop_people}·${info.shop_label}`"></div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="tabs flx alc">
                <div class="tabItem cursor" :class="cur == 0?'ac' : ''" @click="changeTab(0)">
                    公司简介
                    <div class="tabbhng" v-if="cur == 0"></div>
                </div>
                <div class="tabItem cursor" :class="cur == 1?'ac' : ''" @click="changeTab(1)">
                    在聘职位
                    <div class="tabbhng" v-if="cur == 1"></div>
                </div>
            </div>
            <div v-if="cur == 0">
                <div class="pointro">
                    <div class="potite">
                        <div class="poname">
                            公司介绍
                        </div>
                        <div class="pobk"></div>
                    </div>
                    <div class="comintros">
                        <div class="lcocjk" v-text="info.shop_intro"></div>
                    </div>
                </div>
                <!-- <div class="pointro">
                    <div class="potite">
                        <div class="poname">
                            工商信息
                        </div>
                        <div class="pobk"></div>
                    </div>
                    <div class="copinfo flx alc">
                        <div class="coi flx alc">
                            <div class="cole">公司全称</div>
                            <div class="cole" v-text="info.zz_name"></div>
                        </div>
                        <div class="coi flx alc">
                            <div class="cole">法定代表人</div>
                            <div class="cole" v-text="info.zz_qiye"></div>
                        </div>
                        <div class="coi flx alc">
                            <div class="cole">注册资本</div>
                            <div class="cole" v-text="info.zz_ziben"></div>
                        </div>
                        <div class="coi flx alc">
                            <div class="cole">成立时间</div>
                            <div class="cole" v-text="info.zz_time"></div>
                        </div>
                    </div>
                </div> -->
                <div class="pointro">
                    <div class="potite">
                        <div class="poname">
                            公司地址
                        </div>
                        <div class="pobk"></div>
                    </div>
                    <div class="poContent" v-text="info.shop_address"></div>
                </div>
                <div class="pointro" v-if="info.shop_images.length > 0">
                    <div class="potite">
                        <div class="poname">
                            公司相册
                        </div>
                        <div class="pobk"></div>
                    </div>
                    <div class="images flx alc">
                        <div class="coimgitem" v-for="item,index in info.shop_images">
                            <img :src="$img(item)" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="comzw">
                <div>
                    <div class="reItem flx alc jsb" v-for="item,index in list" @click="toDetail(item)">
                        <div class="reLeft">
                            <div class="rlt flx alc">
                                <div class="rname" v-text="item.name"></div>
                                <div class="rsalary" v-if="item.salary_mix > 0 && item.salary_max > 0" v-text="`${item.salary_mix}K ~ ${item.salary_max}K`"></div>
                                <div class="rsalary" v-else>面议</div>
                            </div>
                            <div class="rlv flx alc">
                                <div class="rlabel" v-text="item.exp_name"></div>
                                <div class="rlabel" v-text="item.eb_name"></div>
                            </div>
                            <div class="rlb flx alc">
                                <i class="el-icon-location" style="color: #555C70;"></i>
                                <span v-text="item.city_name"></span>
                                <span> · </span>
                                <span v-text="item.area_name"></span>
                            </div>
                        </div>
                        <div class="remiddle">
                            <div class="comTop flx alc">
                                <img src="https://two.hrxsl.com/pcImages/companyzw.png" alt="">
                                <div v-text="item.shop_name"></div>
                            </div>
                            <div class="rlv flx alc">
                                <div class="rlabel" v-if="item.shop_people" v-text="`${item.shop_people}`"></div>
                                <div class="rlabel" v-if="item.shop_label" v-text="item.shop_label"></div>
                            </div>
                        </div>
                        <div class="reRight">
                            投递简历
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        getCompanyInfo,
        getRecruList
    } from "@/api/index.js"
    export default {
        name: "index",
        data() {
            return {
                info: {},
                cur:0,
                list:[]
            };
        },
        created() {
            this.getDetail()
        },
        methods: {
            toDetail(e){
                let that = this
                this.$router.push({
                    path: '/RecruitmentDetail', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            changeTab(e) {
                let that = this
                if(e == 0){
                    that.cur = 0
                }else{
                    that.getList()
                    that.cur = 1
                }
            },
            getbanner(){},
            getList(){
                let that = this 
                let data = {}
                data.page = that.page
                data.size = 50
                data.company_id = that.$route.query.id
                getRecruList(data).then((res) => {
                    if(res.code == 1){
                        that.list = res.data.data
                    }
                })
            },
            getDetail() {
                let that = this
                let data = {}
                data.company_id = that.$route.query.id
                getCompanyInfo(data).then((res) => {
                    console.log("detail", res)
                    if (res.code == 1) {
                        that.info = res.data
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            }
        }
    };
</script>
<style scoped>
    .comzw{
        min-height: 400px;
    }
    .cons{
        text-align: left;
        width:100vw;
        overflow-x: hidden;
    }
    .reRight{
        width: 88px;
        height: 36px;
        background: #007AFF;
        border-radius: 3px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #FFFFFF;
        cursor: pointer;
    }
    .comTop img{
        width: 22px;
        height: 22px;
        margin-right: 8px;
    }
    .comTop div{
        font-size: 16px;
        color: #222222;
    }
    .rlb{
        font-size: 14px;
        color: #555C70;
    }
    .rlabel{
        height: 23px;
        background: #F5F7FA;
        border-radius: 2px;
        font-size: 12px;
        color: #555C70;
        line-height: 23px;
        padding: 0 9px;
        margin: 12px 0;
        margin-right: 10px;
    }
    .rsalary{
        font-weight: 500;
        font-size: 18px;
        color: #007AFF;
    }
    .rname{
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        margin-right: 14px;
    }
    .reLeft{
        width: 440px;
        
    }
    .reItem{
        background: #fff;
        border-radius: 10px;
        width: 100%;
        box-sizing: border-box;
        padding: 26px;
        margin-top: 16px;
    }
    .reItemns{
        width: 1194px;
       
    }
    .coi .cole:first-child {
        margin-right: 20px;
    }

    .coi {
        margin-right: 101px;
    }

    .copinfo {
        width: 100%;
        margin-top: 20px;
    }

    .cole {
        font-weight: 600;
        font-size: 14px;
        color: #222222;
    }

    .coimgitem {
        width: 300px;
        height: 183px;
        margin-right: 16px;
    }

    .coimgitem img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        object-fit: cover;
    }

    .images {
        width: 100%;
        margin-top: 20px;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .ac {
        font-weight: bold;
        font-size: 20px;
    }

    .tabItem {
        height: 100%;
        position: relative;
        line-height: 54px;
        font-size: 17px;
        color: #4E5366;
        margin-right: 60px;
    }

    .tabbhng {
        width: 39px;
        height: 3px;
        background: #007AFF;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
    }

    .tabs {
        width: 1460px;
        height: 54px;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 0 50px;
        border-radius: 10px;
        margin-top: 16px;
    }

    .jb {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 25px;
    }

    .cheall {
        justify-content: center;
        font-weight: 500;
        font-size: 16px;
        color: #9399AD;
        margin-top: 16px;
        cursor: pointer;
    }

    .lcocjk {
        font-weight: 500;
        font-size: 14px;
        color: #4E5366;
    }

    .innerTitle {
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        margin-bottom: 16px;
    }

    .comintros {
        box-sizing: border-box;
        padding: 20px 0;
    }

    .ciright {
        font-size: 13px;
        color: #222222;
    }

    .comname {
        font-weight: 600;
        font-size: 18px;
        color: #222222;
        line-height: 30px;
    }

    .conma {
        font-size: 13px;
        color: #222222;
        margin-top: 6px;
    }

    .cileft {
        height: 100%;
    }

    .cileft img {
        width: 80px;
        height: 80px;
        border-radius: 6px;
        margin-right: 15px;
        object-fit: cover;
    }

    .companyinfo {}

    .poContent {
        white-space: pre-wrap;
        margin-top: 20px;
        font-size: 16px;
        color: #222222;
        line-height: 30px;
    }

    .poname {
        font-weight: 600;
        font-size: 18px;
        color: #222222;
        z-index: 3;
        position: relative;
    }

    .pobk {
        width: 72px;
        height: 8px;
        background: linear-gradient(90deg, #BAD9FF 0%, rgba(255, 255, 255, 0) 100%);
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .potite {
        position: relative;

    }

    .pointro {
        box-sizing: border-box;
        background: #fff;
        border-radius: 10px;
        padding: 26px;
        margin-top: 16px;
    }

    .sendjl {
        width: 200px;
        height: 48px;
        background: rgba(64, 150, 255, 1);
        border-radius: 6px 6px 6px 6px;
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        line-height: 48px;
    }

    .colbtn img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
    }

    .colbtn {
        width: 112px;
        height: 48px;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid rgba(64, 150, 255, 1);
        justify-content: center;
        color: rgba(64, 150, 255, 1);
        margin-right: 14px;
    }

    .cbb {
        margin-top: 16px;
        color: #555C70;
        font-size: 14px;
    }

    .shu {
        margin: 0 12px;
    }

    .cons {
        box-sizing: border-box;
        padding: 20px 0;
    }

    .rename {
        font-weight: 600;
        font-size: 30px;
        color: #222222;
    }

    .resalary {
        font-weight: 500;
        font-size: 30px;
        color: #007AFF;
        position: relative;
        top: 2px;
        margin-left: 30px;
    }

    .cntop {
        width: 100%;
        box-sizing: border-box;
        padding: 26px;
        background-color: #fff;

    }

    .cns {
        width: 1460px;
        margin: 0 auto;
    }
</style>